import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { usersLoaded } from '../../actions';
import { checkLoggedIn, validateAccess } from '../../session';
import { analyticsActions } from '../../webapi';
import { getPluralS, getPercentage, getPluralOptions } from '../../helper';
import { UTC_OFFSET } from '../../config';
import { compileStats, getInsight, getAnalyticsFilterOptions } from '../../js';
import { AnalyticsFilter } from '../../components';
import { Text } from '../../components/text';

class ServiceHubAnalytics extends Component {
  constructor(props) {
    super(props);
    const filterOptions = getAnalyticsFilterOptions();
    const selectedFilter = filterOptions[1];
    this.state = {
      loading: true,
      stats: {},
      totalStats: {},
      previousStats: null,
      selectedFilter: filterOptions[1],
      currentDayCount: selectedFilter.dayCount,
    };
  }

  UNSAFE_componentWillMount() {
    checkLoggedIn(this, this.props.auth);
  }

  componentDidMount() {
    if (!validateAccess(this.props.auth.site, 'services', this.props.auth, true)) {
      this.props.history.push('/mastermenu');
    } else {
      this.getStats();
    }
  }

  getTotalStat(key) {
    if (!this.state.totalStats[key]) {
      return 0;
    }
    if (Array.isArray(this.state.totalStats[key])) {
      return this.state.totalStats[key].length;
    }
    return this.state.totalStats[key];
  }

  getStat(id, key) {
    if (!this.state.stats[id]) {
      return 0;
    }
    if (!this.state.stats[id][key]) {
      return 0;
    }
    if (Array.isArray(this.state.stats[id][key])) {
      return this.state.stats[id][key].length;
    }
    return this.state.stats[id][key];
  }

  getStats(min, max) {
    this.setState({
      loading: true,
    });
    const lastDay = max ? moment(max).utc() : moment.utc();
    const dayCount = min ? moment(max).diff(moment(min), 'days') : this.state.selectedFilter.dayCount;
    console.log(`getStats: lastDay:${moment(lastDay).format('DD/MM/YYYY')}, dayCount:${dayCount}`);

    const startOfLastDay = lastDay.utcOffset(UTC_OFFSET).startOf('d');
    const minTime = moment(startOfLastDay).add(-dayCount, 'd').valueOf() - 1;
    const maxTime = moment(startOfLastDay).valueOf() - 1;

    analyticsActions.getAggregateEntityStats(this.props.auth.site, 'service', minTime, maxTime).then((res) => {
      console.log(res.data);
      console.log(compileStats(res.data));
      this.setState({
        stats: res.data,
        totalStats: compileStats(res.data),
        loading: false,
        currentDayCount: dayCount,
      });
      const prevMinTime =
        moment(startOfLastDay)
          .add(2 * -dayCount, 'd')
          .valueOf() - 1;
      analyticsActions.getAggregateEntityStats(this.props.auth.site, 'service', prevMinTime, minTime).then((oldRes) => {
        console.log(oldRes.data);
        console.log(compileStats(oldRes.data));
        this.setState({
          previousStats: oldRes.data,
          previousTotalStats: compileStats(oldRes.data),
        });
      });
    });
  }

  filterChanged = (selectedFilter) => {
    this.setState({ selectedFilter }, () => {
      this.getStats();
    });
  };

  filterDateRangeChanged = (startDate, endDate) => {
    this.getStats(startDate, endDate);
  };

  renderStats() {
    if (this.state.loading) {
      return null;
    }
    return (
      <div className="serviceanalytics--overview paddingTop-40">
        <Text type="formTitleSmall" className="marginBottom-16">
          Overview
        </Text>
        <div className="polloverview polloverview--serviceAnalytics">
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="eye" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('PageView')}</p>
              <p className="polloverview_text">Page View{getPluralS(this.getTotalStat('PageView'))}</p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="user" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('UniquePageView')}</p>
              <p className="polloverview_text">Unique Visitor{getPluralS(this.getTotalStat('UniquePageView'))}</p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="ticket" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('BookingCompleted')}</p>
              <p className="polloverview_text">{getPluralOptions(this.getTotalStat('BookingCompleted'), 'Enquiry', 'Enquiries')}</p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="line-chart" />
            <div className="polloverview_right">
              <p className="polloverview_count">{getPercentage(this.getTotalStat('BookingCompleted'), this.getTotalStat('PageView'))}</p>
              <p className="polloverview_text">Conversion Rate</p>
            </div>
          </div>
          <div className="polloverview_section">
            <FontAwesome className="polloverview_icon" name="exclamation-triangle" />
            <div className="polloverview_right">
              <p className="polloverview_count">{this.getTotalStat('BookingStarted') - this.getTotalStat('BookingCompleted')}</p>
              <p className="polloverview_text">
                Partially Completed
                <br />
                Enquiry Form{getPluralS(this.getTotalStat('BookingStarted') - this.getTotalStat('BookingCompleted'))}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInsightService(service, title, primaryStat) {
    if (!service || !service.Entity || !service.Stats) {
      return null;
    }
    const currentStat = service.Stats && service.Stats[primaryStat] ? service.Stats[primaryStat] : 0;
    const prevStat = service.PreviousStats && service.PreviousStats[primaryStat] ? service.PreviousStats[primaryStat] : 0;
    const change = currentStat - prevStat;
    const prevText = this.state.selectedFilter.prevText.replace('*', this.state.currentDayCount);

    return (
      <div className="insights">
        <div className="insightstitle">
          <Text type="formTitleSmall">{title}</Text>
          <div className="hrline"></div>
        </div>
        <div className="insights_section">
          <div className="insightsimg" alt="" style={{ backgroundImage: `url('${service.Entity.Image}')` }}></div>
          <div className="insightsright">
            <p className="fontMedium fontSize-26 text-dusk lineClamp-2">{service.Entity.Title}</p>
            {change === 0 ? (
              <p className="fontHeavy fontSize-13 text-brandingAction">No change on {prevText}</p>
            ) : (
              <p className="fontHeavy fontSize-13 text-brandingAction">
                <FontAwesome className="insightsstat" name={`caret-${change > 0 ? 'up' : 'down'}`} />
                <b>
                  {change} on {prevText}
                </b>
              </p>
            )}

            <div className="insightsnumber">
              <div className="insightsnumleft">
                <p className="polloverview_text marginBottom-8 text-mid">Page View{getPluralS(service.Stats.PageView)}</p>
                <p className="polloverview_text marginBottom-8 text-mid">
                  {getPluralOptions(service.Stats.BookingCompleted, 'Enquiry', 'Enquiries')}
                </p>
                <p className="polloverview_text marginBottom-8 text-mid">Conversion Rate</p>
              </div>
              <div className="insightsnumright">
                <p className="polloverview_num marginBottom-8">{service.Stats.PageView || 0}</p>
                <p className="polloverview_num marginBottom-8">{service.Stats.BookingCompleted || 0}</p>
                <p className="polloverview_num marginBottom-8">{getPercentage(service.Stats.BookingCompleted, service.Stats.PageView)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInsights() {
    if (this.state.loading) {
      return null;
    }
    const mostViewed = getInsight(this.state.stats, this.state.previousStats, this.props.services, 'RowId', 'PageView');
    const mostBooked = getInsight(this.state.stats, this.state.previousStats, this.props.services, 'RowId', 'BookingCompleted');
    if (!mostViewed && !mostBooked) {
      return null;
    }
    return (
      <div className="serviceanalytics--insights paddingTop-40">
        <Text type="formTitleSmall" className="marginBottom-16">
          Insights
        </Text>

        <div className="insightscontainer">
          {this.renderInsightService(mostViewed, 'Most Viewed', 'PageView')}
          {this.renderInsightService(mostBooked, 'Most Enquiries', 'BookingCompleted')}
        </div>
      </div>
    );
  }

  renderServiceList() {
    if (this.state.loading) {
      return null;
    }
    return (
      <div className="paddingTop-40">
        <Table className="plussTable" striped bordered condensed hover style={{ minWidth: '100%' }}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Page Views</th>
              <th>Enquiries</th>
            </tr>
          </thead>
          <tbody>
            {_.sortBy(_.sortBy(this.props.services, 'Title'), (service) => {
              return this.getStat(service.RowId, 'PageView');
            })
              .reverse()
              .map((service) => {
                return (
                  <tr key={service.RowId}>
                    <td>{service.Title}</td>
                    <td>{this.getStat(service.RowId, 'PageView')}</td>
                    <td>{this.getStat(service.RowId, 'BookingCompleted')}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    );
  }

  renderFilter() {
    return (
      <AnalyticsFilter
        defaultFilter={this.state.selectedFilter}
        filterChanged={this.filterChanged}
        filterDateRangeChanged={this.filterDateRangeChanged}
      />
    );
  }

  render() {
    return (
      <div style={{ minWidth: '100%' }}>
        <p className="fontMedium fontSize-36 text-dark">Analytics</p>
        {this.renderFilter()}
        {this.renderStats()}
        {this.renderInsights()}
        {this.renderServiceList()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth,
  };
};

export default connect(mapStateToProps, { usersLoaded })(withRouter(ServiceHubAnalytics));
